import { CircularProgress, Grid, Paper, Typography } from '@mui/material';
import ImportedOutgoEditTable from 'components/molecules/ImportedOutgoEditTable';
import HeaderAndSidebar from 'components/templates/HeaderAndSidebar';
import { ImportedOutgo as ImportedOutgoType, ImportedOutgoDetail } from 'types';

type Props = {
  isLoading: boolean;
  importedOutgo: ImportedOutgoType;
  onClickCsvImport: (fileName: string, content: string) => void;
  onClickUpdateImportedOutgoDetail: (updated: ImportedOutgoDetail) => void;
  onClickDeleteImportedOutgoDetail: (updated: ImportedOutgoDetail) => void;
  onClickApply: () => void;
  onClickDelete: () => void;
};

const ImportedOutgo: React.FC<Props> = ({
  isLoading,
  importedOutgo,
  onClickCsvImport,
  onClickUpdateImportedOutgoDetail,
  onClickDeleteImportedOutgoDetail,
  onClickApply,
  onClickDelete,
}) => (
  <HeaderAndSidebar pageTitle="月別収支">
    <Grid item xs={12} md={12} lg={12}>
      <Typography component="h2" variant="h5" color="inherit">
        CSV インポート
      </Typography>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <ImportedOutgoEditTable
            importedOutgo={importedOutgo}
            onClickCsvImport={onClickCsvImport}
            onClickUpdateImportedOutgoDetail={onClickUpdateImportedOutgoDetail}
            onClickDeleteImportedOutgoDetail={onClickDeleteImportedOutgoDetail}
            onClickApply={onClickApply}
            onClickDelete={onClickDelete}
          />
        )}
      </Paper>
    </Grid>
  </HeaderAndSidebar>
);

export default ImportedOutgo;
